/* eslint-disable no-param-reassign */
import { get } from 'lodash';
import BigNumber from 'bignumber.js';
import {
  fetchConsumptionItem,
  fetchForceToRefundSuccess,
  fetchFrontConsume,
  fetchQueryFrontConsume,
  fetchRefundPage,
  fetchRetryRefund,
  fetchQueryOrderDetail,
  fetchGoodsDetail,
  fetchUpdateFrontConsume,
  fetchUpdateRefoundConsume,
  goodsRefoundApi,
} from '@/api/transaction';
import { Calculator } from '@/utils/number';
import actionType from './actionType';

export const clearData = (state) => {
  return {
    type: actionType.CLEAR_DATA,
    payload: state,
  };
};

export const saveData = (state) => {
  return {
    type: actionType.SAVE_DATA,
    payload: state,
  };
};

export const toggleLoading = (state) => {
  return {
    type: actionType.TOGGLE_LOADING,
    payload: state,
  };
};

export const setPagination = (state) => {
  return {
    type: actionType.SET_PAGINATION,
    payload: state,
  };
};

export const resetPagination = (state) => {
  return {
    type: actionType.RESET_PAGINATION,
    payload: state,
  };
};

export const setTime = (state) => {
  return {
    type: actionType.SET_TIME,
    payload: state,
  };
};

export const reset = (state) => {
  return {
    type: actionType.RESET,
    payload: state,
  };
};

// 消费账务项目
export const getConsumptionItem = () => {
  return async (dispatch) => {
    dispatch(toggleLoading(''));
    let consumptionItemList = [];
    try {
      const res = await fetchConsumptionItem();
      if (res.code === 0) {
        const list = get(res, 'data', []);
        consumptionItemList = list?.map((item) => ({
          label: item.name,
          value: item.code,
        }));
      }
      dispatch(toggleLoading(''));
    } catch (error) {
      dispatch(toggleLoading(''));
    } finally {
      dispatch({
        type: actionType.COMSUMPTION_ITEM_LIST,
        payload: {
          consumptionItemList,
        },
      });
    }
  };
};

// 前台消费
export const consumerAtTheFrontDesk = (data) => {
  return async (dispatch) => {
    dispatch(toggleLoading('consumerAtTheFrontDeskLoading'));
    let payOrderNo = '';
    try {
      const res = await fetchFrontConsume(data);
      if (res.code === 0) {
        payOrderNo = get(res, 'data', '');

        return Promise.resolve(payOrderNo);
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject();
    } finally {
      dispatch(toggleLoading('consumerAtTheFrontDeskLoading'));
      dispatch({
        type: actionType.FRONT_CONSUME,
        payload: {
          payOrderNo,
        },
      });
    }
  };
};

// 前台业务订单
export const getFrontConsumeList = (data) => {
  return async (dispatch, getState) => {
    dispatch(toggleLoading('frontConsumeListLoading'));
    let frontConsumeList = [];
    const initialState = getState().transaction;
    const { pageSize } = initialState;
    let { pageNum, total } = initialState;
    try {
      const res = await fetchQueryFrontConsume({ pageNum, pageSize, ...data });
      if (res.code === 0) {
        frontConsumeList = get(res, 'data.list', []);
        pageNum = get(res, 'data.pageNum', 1);
        total = get(res, 'data.total', 0);
      }
    } catch (error) {
      //
      pageNum = 1;
      total = 0;
    } finally {
      dispatch(toggleLoading('frontConsumeListLoading'));
      dispatch({
        type: actionType.FRONT_CONSUME_LIST,
        payload: {
          frontConsumeList,
          pageNum,
          total,
        },
      });
    }
  };
};

// 订单详情
export const getOrderDetail = (data) => {
  return async (dispatch) => {
    dispatch(toggleLoading('getOrderDetailLoading'));
    let orderInfoList = [];
    let crossNightRefundInfoList = [];

    try {
      const res = await fetchQueryOrderDetail({ ...data });
      if (res.code === 0) {
        orderInfoList = get(res, 'data.orderInfoList', []);
        crossNightRefundInfoList = get(res, 'data.crossNightRefundInfoList', []);
      }
    } catch (error) {
      dispatch(toggleLoading('getOrderDetailLoading'));
    } finally {
      dispatch(toggleLoading('getOrderDetailLoading'));
      // 数据处理
      orderInfoList = orderInfoList.map((item) => {
        item.id = item.no;
        item.mainNo = data.no;
        return item;
      });
      crossNightRefundInfoList = crossNightRefundInfoList.map((item) => {
        item.id = item.no;
        item.mainNo = data.no;
        return item;
      });
      dispatch({
        type: actionType.GET_ORDER_DETAIL,
        payload: {
          orderInfoList,
          crossNightRefundInfoList,
        },
      });
    }
  };
};

// 商品明细
export const getGoodsDetail = (data) => {
  return async (dispatch) => {
    dispatch(toggleLoading('getGoodsDetailLoading'));
    let amount = 0;
    let count = 0;
    let frontGoods = [];

    try {
      const res = await fetchGoodsDetail({ ...data });
      if (res.code === 0) {
        amount = get(res, 'data.amount', 0);
        count = get(res, 'data.count', 0);
        frontGoods = get(res, 'data.frontGoods', []);
        // 商品明细数据处理
        frontGoods.map((item: any) => {
          item.currentQty = item.qty;
          item.currentSubtotal = item.subtotal;
          return item;
        });
        dispatch(toggleLoading('getGoodsDetailLoading'));
        dispatch({
          type: actionType.GET_GOODS_DETAIL,
          payload: {
            amount,
            count,
            currentAmount: amount,
            currentCount: count,
            frontGoods,
          },
        });
      }
    } catch (error) {
      dispatch(toggleLoading('getGoodsDetailLoading'));
    }
  };
};

// 部分退货退款
export const changeInitGoodsInfo = (data) => {
  return (dispatch, getState) => {
    const { frontGoods } = getState().transaction;
    const currentCount = new Calculator();
    const currentAmount = new Calculator();
    frontGoods.map((item) => {
      if (item.code === data.code) {
        item.currentQty = Number(data.currentQty);
        item.currentSubtotal = new BigNumber(data.currentSubtotal).times(100).toNumber();
      }
      currentCount.plus(item.currentQty);
      currentAmount.plus(item.currentSubtotal);
      return item;
    });
    dispatch({
      type: actionType.SET_GOODS_DETAIL,
      payload: {
        frontGoods,
        currentCount: Number(currentCount.getValue()),
        currentAmount: Number(currentAmount.getValue()),
      },
    });
  };
};

// 修改前台备注
export const updateFrontConsume = (data) => {
  return async (dispatch) => {
    dispatch(toggleLoading(''));
    try {
      const res = await fetchUpdateFrontConsume(data);
      if (res.code === 0) {
        return Promise.resolve();
      }
      dispatch(toggleLoading(''));
      return Promise.reject();
    } catch (error) {
      dispatch(toggleLoading(''));
      return Promise.reject();
    }
  };
};

// 修改退款单备注
export const updateRefoundConsume = (data) => {
  return async (dispatch) => {
    dispatch(toggleLoading(''));
    try {
      const res = await fetchUpdateRefoundConsume(data);
      if (res.code === 0) {
        return Promise.resolve();
      }
      dispatch(toggleLoading(''));
      return Promise.reject();
    } catch (error) {
      dispatch(toggleLoading(''));
      return Promise.reject();
    }
  };
};

// 退款列表
export const getRefundPage = (data) => {
  return async (dispatch, getState) => {
    dispatch(toggleLoading('refundPageLoading'));
    let refundList = [];
    const initialState = getState().transaction;
    const { pageSize } = initialState;
    let { pageNum, total } = initialState;
    try {
      const res = await fetchRefundPage({ pageNum, pageSize, ...data });
      if (res.code === 0) {
        refundList = get(res, 'data.list', []);
        pageNum = get(res, 'data.pageNum', 1);
        total = get(res, 'data.total', 0);
        return Promise.resolve();
      }
      return Promise.reject();
    } catch (error) {
      //
      return Promise.reject();
    } finally {
      dispatch(toggleLoading('refundPageLoading'));
      dispatch({
        type: actionType.REFUND_PAGE,
        payload: {
          refundList,
          pageNum,
          total,
        },
      });
    }
  };
};

// 强制成功
export const forceToRefund = (data) => {
  return async () => {
    try {
      const res = await fetchForceToRefundSuccess(data);
      if (res.code === 0) {
        return Promise.resolve();
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject();
    }
  };
};

// 重试
export const retryRefund = (data) => {
  return async () => {
    try {
      const res = await fetchRetryRefund(data);
      if (res.code === 0) {
        return Promise.resolve();
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject();
    }
  };
};

// 商品退货退款
export const goodsRefound = (data) => {
  return async (dispatch) => {
    dispatch(toggleLoading(''));
    try {
      const res = await goodsRefoundApi(data);
      if (res.code === 0) {
        return Promise.resolve();
      }
      dispatch(toggleLoading(''));
      return Promise.reject();
    } catch (error) {
      dispatch(toggleLoading(''));
      return Promise.reject();
    }
  };
};
